import { schema } from 'normalizr';
import retailerSchema from './retailerSchema';

const storeSchema = new schema.Entity('store', {
  retailer: retailerSchema,
});

export default storeSchema;
